<div class="dashboard-contents {{columnClass}}" >
    <ng-container *ngFor="let dummy of dummyArray">
        <ng-template template-host></ng-template>
    </ng-container>
</div>